import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Input,
    Select,
    Modal,
    Typography,
    Button,
    DatePicker,
    Col,
    Row,
    TimePicker,
    notification,
    Radio,
    Checkbox,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import ColdTraceabilityApi from "../../Apis/ColdTraceabilityApi";
import ProductApi from "../../Apis/ProductApi";
import { InfoCircleFilled } from "@ant-design/icons";
import StorageSelectProduction from "../../DropDowns/Stock/StorageSelectProduction";
import StockApi from "../../Apis/StockApi";
import ProductionApi from "../../Apis/ProductionApi";
import RecipeApi from "../../Apis/RecipeApi";
import IngredientsApi from "../../Apis/IngredientsApi";
const { Title } = Typography;

function AddColdTTrace({ visible, onClose, ProductctionDetails, storageUnit }) {
    const [formAdd] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));

    useEffect(() => {
        if (ProductctionDetails?.storageDTO?.id) {
            formAdd.setFieldsValue({ storageUnit: ProductctionDetails.storageDTO.id });
        }
    }, [ProductctionDetails, formAdd]);

    const currentDate = moment().format("DD/MM/YYYY");
    const currentTime = moment().format("h:mm a");

    const [Products, setProducts] = React.useState([]);
    const [ProductGroups, setProductGroups] = React.useState({});
    const [IngredientId, setIngredientId] = useState(0);
    const [selectedSellByDate, setSelectedSellByDate] = useState(null);

    // Store all products and groups in refs for caching
    const allProductsRef = useRef([]);
    const allProductGroupsRef = useRef({});
    const isLoadingRef = useRef(false);
    const dataLoadedRef = useRef(false);

    // Helper function to extract base batch code (remove supplier prefix)
    const extractBaseBatchCode = (batchCode) => {
        if (!batchCode) return '';
        const match = batchCode.match(/#(.+)$/);
        if (match) {
            return match[1];
        }
        return batchCode;
    };

    const loadAllIngredients = useCallback(async () => {
    if (isLoadingRef.current) return;

    isLoadingRef.current = true;

    try {
        let currentPage = 0;
        let hasMore = true;
        const allGroups = {};

        while (hasMore) {
            const response = await ProductApi.ListproductsStock(currentPage, 50);

            if (!response?.payloadDto || response.payloadDto.length === 0) {
                hasMore = false;
                break;
            }

            // Add products directly into the common allGroups object
            response.payloadDto.forEach((product) => {
                const productCode = product?.productCode || '';
                const baseBatchCode = extractBaseBatchCode(productCode);

                if (!baseBatchCode) return;

                // Create group if it doesn't already exist
                if (!allGroups[baseBatchCode]) {
                    allGroups[baseBatchCode] = {
                        baseBatchCode,
                        ingredients: []
                    };
                }

                // Add product to existing group
                allGroups[baseBatchCode].ingredients.push({
                    ...product,
                    ingredientId: product.id,
                    productId: product?.id,
                    productName: product?.productName,
                    batchCode: product?.productCode
                });
            });

            currentPage++;

            if (currentPage >= response.totalPages) {
                hasMore = false;
            }
        }

        // Store all groups
        allProductGroupsRef.current = allGroups;
        setProductGroups(allGroups);

        // Create dropdown products
        const allProducts = Object.keys(allGroups).map((key) => {
            const group = allGroups[key];

            const firstProductName =
                group.ingredients[0]?.productName || key;

            return {
                baseBatchCode: key,
                displayName: firstProductName,
                ingredients: group.ingredients,
                supplierCount: group.ingredients.length
            };
        });

        allProductsRef.current = allProducts;
        setProducts(allProducts);

    } catch (error) {
        console.error("Error fetching ingredients:", error);

        notification.open({
            message: (
                <span style={{ fontWeight: "bold" }}>
                    Error
                </span>
            ),
            description: "Failed to load products. Please try again.",
            closeIcon: false,
            duration: 3,
            style: {
                backgroundColor: "#fff2f0",
                color: "red",
            },
        });

    } finally {
        isLoadingRef.current = false;
    }
}, []);

        useEffect(() => {
        // Reset the loaded flag when modal closes
        if (!visible) {
            dataLoadedRef.current = false;
            // Reset form and states when modal closes
            formAdd.resetFields();
            setSelectedItems([]);
            setStockProduct2(null);
            setSelectedSellByDate(null);
            setProduction([]);
            setIngredientId(0);
            setbtnDisable(false);
            submittingRef.current = false;
            setQuantityValid(false);
            return;
        }

        // Load data only if not already loaded for this session
        if (!dataLoadedRef.current && visible) {
            loadAllIngredients();
            dataLoadedRef.current = true;
        }

        const intervalID = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(intervalID);
    }, [visible, loadAllIngredients, formAdd]);

    // Optimized search - filters from cached data
    const handleInputChangeProduct = (searchText) => {
        if (!searchText || searchText.trim() === '') {
            // Show all products from cache
            setProducts(allProductsRef.current);
            return;
        }

        // Filter from cached products
        const searchLower = searchText.toLowerCase().trim();
        const filtered = allProductsRef.current.filter(product => 
            product.displayName.toLowerCase().includes(searchLower)
        );
        
        setProducts(filtered);
    };

    const [StockProduct2, setStockProduct2] = React.useState();

    const handleCancel = () => {
        formAdd.resetFields();
        setSelectedItems([]);
        setStockProduct2(null);
        setSelectedSellByDate(null);
        setProduction([]);
        setIngredientId(0);
        setbtnDisable(false);
        submittingRef.current = false;
        setQuantityValid(false);
        onClose();
    };

    const [ShelfLifeProduct, setShelfLifeProduct] = React.useState();

    function compareDates(creationDate) {
        if (!creationDate) return true;  
        const today = dayjs().endOf('day');
        const itemDate = dayjs(creationDate).endOf('day');
        if (ShelfLifeProduct?.coolingShelfLifeDTO?.period) {
            const pastDate = itemDate.subtract(
                ShelfLifeProduct?.coolingShelfLifeDTO?.period,
                ShelfLifeProduct?.coolingShelfLifeDTO?.periodType
            );
            return pastDate.isBefore(today);
        } else {
            return itemDate.isBefore(today);
        }
    }

    const handleChangeProduct = (value) => {
        setStockProduct2(null);
        setSelectedItems([]);
        setProduction([]);
        
        const baseBatchCode = value;
        const productGroup = ProductGroups[baseBatchCode];
        
        if (!productGroup || !productGroup.ingredients || productGroup.ingredients.length === 0) {
            console.log("No product group found for batch code:", baseBatchCode);
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: "No ingredients found for this batch code",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
            return;
        }
        
        const uniqueIngredients = productGroup.ingredients;
        const firstIngredient = uniqueIngredients[0];
        const productId = firstIngredient?.id;
        
        IngredientsApi.SingleProducts(productId)  
            .then((ingredientResponse) => {
                const actualIngredientId = ingredientResponse?.payload?.id;
                setIngredientId(actualIngredientId);
                console.log("Ingredient table ID:", actualIngredientId);
            })
            .catch((err) => {
                console.error("Failed to fetch ingredient ID:", err);
            });
            
        ProductApi.SingleProducts(productId).then((response) => {
            setStockProduct2(response.payload);
            setShelfLifeProduct(response.payload);

            const shelfLifePeriod = parseInt(response.payload?.shelfLifeDTO?.period);
            const shelfLifeperiodType = response.payload?.shelfLifeDTO?.periodType;

            const currentDate = dayjs();
            const futureDate = currentDate.add(shelfLifePeriod, shelfLifeperiodType);
            const formattedFutureDate = dayjs(futureDate);
            
            // Fetch stock items for ALL ingredients
            const stockPromises = uniqueIngredients.map(ingredient => 
                StockApi.ListStockProduct(ingredient?.id)
                    .then(stockResponse => ({
                        ingredient: ingredient,
                        stockData: stockResponse
                    }))
                    .catch(err => ({
                        ingredient: ingredient,
                        stockData: null,
                        error: err
                    }))
            );
            
            Promise.all(stockPromises)
                .then((allStockResponses) => {
                    let allStockItems = [];
                    let hasStock = false;
                    
                    allStockResponses.forEach(({ ingredient, stockData, error }) => {
                        if (stockData && stockData.payload && stockData.payload.length > 0) {
                            // ONLY get items with stock > 0 - filter out zero stock
                            const validStockItems = stockData.payload.filter(item => 
                                parseFloat(item.unitOfMeasurement1) > 0.01
                            );
                            
                            if (validStockItems.length > 0) {
                                hasStock = true;
                                // Add ingredient info to each stock item
                                const stockWithIngredient = validStockItems.map(item => ({
                                    ...item,
                                    ingredientId: ingredient.ingredientId,
                                    ingredientName: ingredient?.productName || ingredient.name,
                                    ingredientIdValue: ingredient.id,
                                    baseBatchCode: baseBatchCode,
                                    supplierName: ingredient.name || 'Unknown Supplier'
                                }));
                                allStockItems = [...allStockItems, ...stockWithIngredient];
                            }
                        }
                    });
                    
                    console.log("All stock items with stock > 0:", allStockItems);
                    
                    // ✅ FIXED: Sort items using endOf('day') so today's expiry is NOT expired
                    const today = dayjs().endOf('day');
                    const sortedStockItems = allStockItems.sort((a, b) => {
                        const aExpiry = a.expiryDate ? dayjs(a.expiryDate).endOf('day') : null;
                        const bExpiry = b.expiryDate ? dayjs(b.expiryDate).endOf('day') : null;
                        
                        const aIsExpired = aExpiry ? aExpiry.isBefore(today) : true;
                        const bIsExpired = bExpiry ? bExpiry.isBefore(today) : true;
                        
                        // Non-expired items come first
                        if (!aIsExpired && bIsExpired) return -1;
                        if (aIsExpired && !bIsExpired) return 1;
                        
                        // If both are non-expired, sort by expiry date (earliest first)
                        if (!aIsExpired && !bIsExpired) {
                            return aExpiry.isBefore(bExpiry) ? -1 : 1;
                        }
                        
                        // If both are expired, sort by expiry date (latest/most recent first)
                        if (aIsExpired && bIsExpired) {
                            return aExpiry.isAfter(bExpiry) ? -1 : 1;
                        }
                        
                        return 0;
                    });
                    
                    setProduction(sortedStockItems);
                    
                    // Calculate future date based on shelf life
                    let futureDate2;
                    if (response.payload?.shelfLifeDTO?.period && response.payload?.shelfLifeDTO?.periodType) {
                        futureDate2 = currentDate.add(shelfLifePeriod, shelfLifeperiodType);
                    } else {
                        futureDate2 = currentDate;
                    }
                    
                    console.log("Current Date:", currentDate.format("YYYY-MM-DD"));
                    console.log("Shelf Life:", shelfLifePeriod, shelfLifeperiodType);
                    console.log("Future Date (Shelf Life):", futureDate2.format("YYYY-MM-DD"));
                    
                    // Find expiry dates from items with stock > 0
                    let earliestValidExpiryDate = null;
                    let latestExpiredDate = null;
                    let hasValidStock = false;
                    let hasExpiredStock = false;
                    
                    if (sortedStockItems && sortedStockItems.length > 0) {
                        for (const item of sortedStockItems) {
                            if (item.expiryDate) {
                                // ✅ FIXED: use endOf('day') so today's expiry is valid
                                const expiryDate = dayjs(item.expiryDate).endOf('day');
                                const isExpired = expiryDate.isBefore(today);
                                
                                console.log(`Item ${item.id} expiry:`, expiryDate.format("YYYY-MM-DD"), 
                                          "Quantity:", item.unitOfMeasurement1, 
                                          "Expired:", isExpired);
                                
                                if (!isExpired) {
                                    hasValidStock = true;
                                    if (!earliestValidExpiryDate || expiryDate.isBefore(earliestValidExpiryDate)) {
                                        earliestValidExpiryDate = expiryDate;
                                    }
                                } else {
                                    hasExpiredStock = true;
                                    if (!latestExpiredDate || expiryDate.isAfter(latestExpiredDate)) {
                                        latestExpiredDate = expiryDate;
                                    }
                                }
                            }
                        }
                    }
                    
                    console.log("Earliest Valid Expiry Date (from non-expired items):", 
                               earliestValidExpiryDate ? earliestValidExpiryDate.format("YYYY-MM-DD") : "None");
                    console.log("Latest Expired Date (most recent expiry):", 
                               latestExpiredDate ? latestExpiredDate.format("YYYY-MM-DD") : "None");
                    
                    // Determine the final sell by date
                    let finalSellByDate;
                    
                    if (hasValidStock && earliestValidExpiryDate) {
                        if (futureDate2.isAfter(earliestValidExpiryDate)) {
                            finalSellByDate = earliestValidExpiryDate.format("YYYY-MM-DD");
                            console.log("Future date exceeds valid stock expiry, using earliest valid expiry:", finalSellByDate);
                        } else {
                            finalSellByDate = futureDate2.format("YYYY-MM-DD");
                            console.log("Using future date:", finalSellByDate);
                        }
                        
                        if (response.payload?.expiryDate) {
                            const productExpiry = dayjs(response.payload.expiryDate).endOf('day');
                            const sellByDate = dayjs(finalSellByDate).endOf('day');
                            if (sellByDate.isAfter(productExpiry)) {
                                finalSellByDate = productExpiry.format("YYYY-MM-DD");
                                console.log("Sell by date exceeds product expiry, using product expiry:", finalSellByDate);
                            }
                        }
                    } else if (hasExpiredStock && latestExpiredDate) {
                        finalSellByDate = latestExpiredDate.format("YYYY-MM-DD");
                        console.log("All stock expired, using latest expired date:", finalSellByDate);
                        
                        notification.open({
                            message: <span style={{ fontWeight: "bold" }}>All Stock Expired</span>,
                            description: `All available stock is expired.`,
                            closeIcon: false,
                            duration: 5,
                            style: {
                                backgroundColor: "#fff7e6",
                                color: "#fa8c16",
                            },
                        });
                    } else {
                        if (response.payload?.expiryDate) {
                            const productExpiry = dayjs(response.payload.expiryDate).endOf('day');
                            if (futureDate2.isBefore(productExpiry)) {
                                finalSellByDate = futureDate2.format("YYYY-MM-DD");
                            } else {
                                finalSellByDate = productExpiry.format("YYYY-MM-DD");
                            }
                            console.log("No stock available, using product expiry date:", finalSellByDate);
                        } else {
                            finalSellByDate = futureDate2.format("YYYY-MM-DD");
                            console.log("No stock and no product expiry, using future date:", finalSellByDate);
                        }
                    }
                    
                    formAdd.setFieldsValue({
                        coSellByDate: finalSellByDate,
                    });
                    setSelectedSellByDate(finalSellByDate);
                    
                    if (!hasStock) {
                        notification.open({
                            message: <span style={{ fontWeight: "bold" }}>No Stock Available</span>,
                            description: `No stock available for any supplier of this product`,
                            closeIcon: false,
                            duration: 3,
                            style: {
                                backgroundColor: "#fff7e6",
                                color: "#fa8c16",
                            },
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError?.status || "Error"}</span>
                        ),
                        description: err.apiError?.message || "Failed to fetch stock items",
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                });
        })
        .catch((err) => {
            console.log(err);
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: "Failed to fetch product details",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        });
    };

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    
    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }

    const [QuantityValid, setQuantityValid] = React.useState(false);
    const [btnDisable, setbtnDisable] = useState(false);
    const submittingRef = useRef(false);
        
    const handleSubmit = (data) => {
        
        if (submittingRef.current) return;
        submittingRef.current = true;
        setbtnDisable(true);
        
        if (selectedItems.length === 0) {
            setQuantityValid(false);
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>No Stock Selected</span>,
                description: "Please select at least one stock row.",
                closeIcon: false,
                duration: 3,
                style: { backgroundColor: "#fff2f0", color: "red" },
            });
            return;
        }
        
        const selectedItem = selectedItems[0];
        const requestedQuantity = parseFloat(selectedItem?.quantity);
        const availableQuantity = parseFloat(selectedItem?.unitOfMeasurement1);

        if (!IngredientId) {
            submittingRef.current = false;
            setbtnDisable(false);
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Please wait</span>,
                description: "Ingredient data is still loading. Try again in a moment.",
                closeIcon: false,
                duration: 3,
                style: { backgroundColor: "#fff7e6", color: "#fa8c16" },
            });
            return;
        }
        const failValidation = () => {
        submittingRef.current = false;
        setbtnDisable(false);
    };

        if (requestedQuantity > availableQuantity) {
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Insufficient Stock</span>,
                description: `Requested quantity (${requestedQuantity} ${selectedItem.unit2}) exceeds available stock (${availableQuantity} ${StockProduct2?.unitUomTwo})`,
                closeIcon: false,
                duration: 5,
                style: { backgroundColor: "#fff2f0", color: "red" },
            });
            failValidation();
            return;
        }


    // Validate every selected row
    for (const item of selectedItems) {
        if (!item.quantity || parseFloat(item.quantity) <= 0) {
            setQuantityValid(true);
            return;
        }
        const requestedBase = parseFloat(item.quantity);
        const availableBase = parseFloat(item.unitOfMeasurement1) || 0;
        if (requestedBase > availableBase + 0.0001) {
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Insufficient Stock</span>,
                description: `Batch ${item.batchCode}: requested ${requestedBase} ${StockProduct2?.unitUomTwo} exceeds available ${availableBase} ${StockProduct2?.unitUomTwo}`,
                closeIcon: false,
                duration: 5,
                style: { backgroundColor: "#fff2f0", color: "red" },
            });
            failValidation();
            return;
        }
    }
        
        setQuantityValid(false);
        setbtnDisable(true);

        const prodTimeDayjs = dayjs(data.prodTime);
        const formattedTime = prodTimeDayjs.format('HH:mm');
        const prodTimeN   = prodTimeDayjs.valueOf();

        const SelectDate = dayjs(data.createDate).format("DD/MM/YYYY");
        const sellDate = dayjs(data.coSellByDate).format("DD/MM/YYYY");

        const selectedStockItem = selectedItems[0];
        const stockId = selectedStockItem?.id;

        const stockBatchCodeList = selectedItems.map(item => `${item.batchCode}//${item.id}`);
        
        const totalQuantityUom2 = selectedItems.reduce(
        (sum, it) => sum + (parseFloat(it.quantity) || 0), 0
    );

        const primaryUnit = selectedItems[0]?.unit2;

        const totalQuantityInPrimaryUnit = (() => {
            if (primaryUnit === StockProduct2?.unitUomOne) {
                return totalQuantityUom2 / parseFloat(StockProduct2?.unitOfMeasurement2 || 1);
            }
            if (primaryUnit === StockProduct2?.unitUomThree) {
                return totalQuantityUom2 * parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
            }
            return totalQuantityUom2; 
        })();

        const groupKey = extractBaseBatchCode(selectedItems[0]?.batchCode);
        const group = ProductGroups[groupKey];
        const displayName = group?.ingredients[0]?.productName || StockProduct2?.productName || 'Product';

        const totalCost = selectedItems.reduce(
        (sum, it) => sum + (parseFloat(it.quantity) || 0) * parseFloat(StockProduct2?.costPriceUoM2 || 0),
        0
    );

        const ingredientsDTOList = selectedItems.map(item => ({
            id: IngredientId,
            stockId: item.id,
            unit: item.unit2,
            quantity: item.quantity2,
            stockBatchCodeList: [`${item.batchCode}//${item.id}`],
        }));

        const productionIngredientsList = selectedItems.map(item => ({
            ...item,
            stockId: item.id,
        }));

        let createdRecipeId = null;
        let createdProductionId = null;
        let createdColdTraceId = null;

        // Rollback function
        const rollback = async (step, error) => {
            console.error(`Rollback triggered at step: ${step}`, error);
            
            const failedDeletions = [];

            if (createdColdTraceId) {
                await ColdTraceabilityApi.DeleteColdTraceability(createdColdTraceId)
                    .catch(err => {
                        console.error('Failed to delete ColdTraceability:', err);
                        failedDeletions.push('ColdTraceability');
                    });
            }
            if (createdProductionId) {
                await ProductionApi.deleteProduction(createdProductionId)
                    .catch(err => {
                        console.error('Failed to delete Production:', err);
                        failedDeletions.push('Production');
                    });
            }

            if (createdRecipeId) {
                await RecipeApi.DeleteRecipe(createdRecipeId)
                    .catch(err => {
                        // 404 = already deleted → treat as success
                        if (err?.response?.status === 404 || err?.apiError?.status === 'NOT_FOUND') {
                            console.warn('Recipe already deleted (Step 4 likely succeeded):', createdRecipeId);
                        } else {
                            console.error('Failed to delete Recipe:', err);
                            failedDeletions.push('Recipe');
                        }
                    });
            }

            submittingRef.current = false;
            setbtnDisable(false);

                    if (failedDeletions.length > 0) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Manual Intervention Required</span>,
                        description: `Failed to delete: ${failedDeletions.join(', ')}. 
                                    Records may be orphaned. Please contact support immediately.
                                    Step: ${step}`,
                        closeIcon: false,
                        duration: 10,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                    
                    // Log for debugging
                    console.error('ROLLBACK FAILED:', {
                        step,
                        error: error?.message,
                        failedDeletions,
                        createdRecipeId,
                        createdProductionId,
                        createdColdTraceId,
                        timestamp: new Date().toISOString()
                    });
                } else {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Operation Failed</span>,
                        description: `Failed at step: ${step}. All changes have been rolled back.`,
                        closeIcon: false,
                        duration: 5,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            };

        // Step 1: Create Recipe
        let formData = JSON.stringify({
            recipeName: displayName,
            unit: primaryUnit,
            quantity: totalQuantityInPrimaryUnit,
            ingredientsDTO: ingredientsDTOList,
            institutionDTO: {
                id: StockProduct2?.institutionDTO?.id
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });

        const cleanedStockProduct = StockProduct2 ? {
            ...StockProduct2,
            coolingShelfLifeDTO: StockProduct2.coolingShelfLifeDTO ? {
                ...StockProduct2.coolingShelfLifeDTO,
                description: StockProduct2.coolingShelfLifeDTO.description
                    ?.replace(/°/g, 'deg')
                    ?.replace(/[^\x20-\x7E]/g, '') || ""
            } : null,
            description: StockProduct2.description
                ?.replace(/°/g, 'deg')
                ?.replace(/[^\x20-\x7E]/g, '') || "",
            productName: StockProduct2.productName
                ?.replace(/°/g, 'deg')
                ?.replace(/[^\x20-\x7E]/g, '') || ""
        } : null;

        RecipeApi.CreateRecipe(formData)
            .then((response) => {
                createdRecipeId = response?.payload?.id;
                
                // Step 2: Create Production
                let formData2 = JSON.stringify({
                    cookingTime: formattedTime,
                    sellByDate: convertToUnixTimestamp(sellDate),
                    unit: primaryUnit,
                    quantity: totalQuantityInPrimaryUnit,
                    productionName: response?.payload?.recipeName,
                    currency: '$',
                    batchCode: selectedItems[0]?.batchCode + "-" + response?.payload?.id,
                    userId: decodedToken?.userId,
                    productionCoast: totalCost,
                    allergensDTO: response?.payload.allergenDTOList,
                    productionCreateDate: convertToUnixTimestamp(SelectDate),
                    productDTO: cleanedStockProduct,
                    uomNumber: selectedItems[0]?.unit2 === StockProduct2?.unitUomOne ? 1 : selectedItems[0]?.unit2 === StockProduct2?.unitUomTwo ? 2 : 3,
                    rawProduction: true,
                    stockBatchCodeList: stockBatchCodeList, 
                    recipeDTO: {
                        id: response?.payload?.id,
                        ingredientsDTO: [{
                            id: StockProduct2?.id,
                            ingredientsQuantityDTOList: productionIngredientsList,
                        }],
                    },
                    tenantDTO: {
                        id: decodedToken?.tenantId,
                        tenantApiKey: decodedToken?.tenantApiKey,
                    },
                    institutionDTO: {
                        id: response?.payload?.institutionDTO?.id,
                    },
                });

                return ProductionApi.CreateProduction(formData2);
            })
            .then((response22) => {
                createdProductionId = response22?.payload?.id;
                
                // Step 3: Create Cold Traceability
                let formData3 = JSON.stringify({
                    coldTraceabilityTime: prodTimeN,
                    coldTraceabilityDate: convertToUnixTimestamp(SelectDate),
                    temp: "N/A",
                    quantityOfTheCookedProduct: totalQuantityInPrimaryUnit,
                    correctiveAction: "",
                    oubd: selectedItems[0]?.expiryDate,
                    stockBatchCodeList: stockBatchCodeList,
                    productionDTO: {
                        id: response22?.payload?.id,
                    },
                    storageDTO: {
                        id: data?.storageUnit,
                    },
                    tenantDTO: {
                        id: decodedToken?.tenantId,
                        tenantApiKey: decodedToken?.tenantApiKey,
                    },
                    institutionDTO: {
                        id: response22?.payload?.institutionDTO?.id,
                    },
                });

                return ColdTraceabilityApi.Createcoldtraceability(formData3);
            })
            .then((response44) => {
                createdColdTraceId = response44?.payload?.id;
                
                // Step 4: Update Recipe (Soft Delete)
                // let updatedFormData = JSON.stringify({
                //     recipeName: displayName,
                //     unit: primaryUnit,
                //     quantity: totalQuantityInPrimaryUnit,
                //     ingredientsDTO: ingredientsDTOList,
                //     stockBatchCodeList: stockBatchCodeList, 
                //     institutionDTO: {
                //         id: StockProduct2?.institutionDTO?.id
                //     },
                //     tenantDTO: {
                //         id: decodedToken?.tenantId,
                //         tenantApiKey: decodedToken?.tenantApiKey,
                //     },
                //     isDelete: true
                // });

                return RecipeApi.DeleteRecipe(createdRecipeId);
            })
            .then(() => {
                // Success - all operations completed
                setbtnDisable(false);
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Created</span>,
                    description: "Created Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch(async(err) => {
                // Any error will trigger rollback
                let step = "Unknown";
                if (!createdRecipeId) step = "Recipe Creation";
                else if (!createdProductionId) step = "Production Creation";
                else if (!createdColdTraceId) step = "Cold Traceability Creation";
                else step = "Recipe Update";
                
                await rollback(step, err);
                
                // Show error notification
                setbtnDisable(false);
                if (err.apiError?.status) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                } else {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Error</span>,
                        description: err?.message || "An error occurred. Please try again.",
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };


    const [Production, setProduction] = React.useState([]);
    const [time, setTime] = useState(new Date());
    const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);


    const formattedTimeNew = time.toLocaleTimeString();

    const handleInputKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    const toUom2 = (rawValue, unit) => {
    const val = parseFloat(rawValue);
    if (isNaN(val)) return 0;
    if (unit === StockProduct2?.unitUomOne) {
        return val * parseFloat(StockProduct2?.unitOfMeasurement2 || 1);
    } else if (unit === StockProduct2?.unitUomTwo) {
        return val;
    } else if (unit === StockProduct2?.unitUomThree) {
        return val / parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
    }
    return val;
};

    const handleInputChange = (event, itemId) => {
    const newQuantity = event.target.value.trim();
    setSelectedItems(prevSelectedItems =>
        prevSelectedItems.map(selectedItem => {
            if (selectedItem.id !== itemId.id) return selectedItem;
            return {
                ...selectedItem,
                quantity2: newQuantity,                             
                quantity: toUom2(newQuantity, selectedItem.unit2)     
            };
        })
    );
};

    const handleSelectChange = (event, itemId) => {
    setSelectedItems(prevSelectedItems =>
        prevSelectedItems.map(selectedItem => {
            if (selectedItem.id !== itemId.id) return selectedItem;

            const newUnit2 = event;
            const rawValue = selectedItem.quantity2; 

            return {
                ...selectedItem,
                unit2: newUnit2,
                unit: newUnit2,
                quantity: toUom2(rawValue, newUnit2)
            };
        })
    );
};

    const [selectedItems, setSelectedItems] = useState([]);

    const handleToggleStock = (item) => {
        const exists = selectedItems.some(s => s.id === item.id);
        if (exists) {
            setSelectedItems(prev => prev.filter(s => s.id !== item.id));
        } else {
            const availableStock = parseFloat(item.unitOfMeasurement1) || 0;
            const initialItem = {
                ...item,
                quantity: "0",
                quantity2: "0",
                unit2: StockProduct2?.unitUomOne || item.unit,  
                availableStockInBaseUnit: availableStock
            };
            setSelectedItems(prev => [...prev, initialItem]);
        }
    };

    return (
        <>
            <Modal
                footer={[]}
                width={1200}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Add to Cold Tracebility
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 3,
                    }}
                    wrapperCol={{
                        span: 21,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <div className="my-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                />
                            </div>
                            <div className="px-2" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b>{formattedTimeNew}</b> <img
                                    src="/assest/Images/time.png"
                                    style={{ width: '35px', marginLeft: '10px' }}
                                    className="logo-png"
                                />
                            </div>

                            <Form.Item
                                name="prodTime"
                                initialValue={dayjs(currentTime, "h:mm a")}
                                className="text-lable disabled d-none"
                            >
                                <TimePicker disabled use12Hours format="h:mm a" className="form-control control-input" />
                            </Form.Item>
                        </div>

                        <div className="Product-createDate">
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="disabled text-lable col-lg-6  d-none col-sm-12 col-md-7"
                            >
                                <DatePicker
                                    disabled
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div>

                        <Form.Item
                            name="productId"
                            label="Product :"
                            className="text-lable pt-3 CrossAfter"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product.",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                className="control-Select mb-1"
                                placeholder="Select Product by Batch Code"
                                filterOption={false} // Disable default filtering, we handle it manually
                                onChange={(value) => handleChangeProduct(value)}
                                onSearch={handleInputChangeProduct}
                                allowClear
                            >
                                {Products.map((option, index) => (
                                    <Select.Option 
                                        key={option.baseBatchCode + index} 
                                        value={option.baseBatchCode}
                                    >
                                        {option.displayName}
                                        {option.supplierCount > 1 && 
                                            ` (${option.supplierCount} suppliers)`
                                        }
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Row gutter={24} className="mt-3">
                            <Col lg={24} md={24} >
                                <div className="dateFilterTable">
                                    <table className="table users-table" >
                                        <thead>
                                            <tr style={{ verticalAlign: 'top' }}>
                                                <th className="text-center" style={{ width: '5%' }}></th>
                                                <th style={{ width: '10%' }}>Invoice #</th>
                                                <th style={{ width: '15%' }}>Batch Code</th>
                                                <th className="text-center" style={{ width: '15%' }}>OUBD<br /> <p className="mb-0 pb-0" style={{ color: 'gray', fontSize: '12px' }}>(Original Used by Date)</p></th>
                                                <th className="text-center" style={{ width: '10%' }}>Qty(UOM2)</th>
                                                <th style={{ width: '10%' }}>Qty(UOM3)</th>
                                                <th className="text-center" style={{ width: '23%' }}>Adding Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody className={Production?.length > 6 ? 'tableScroll' : ''}>
                                            {Production.map((item, index) => {
                                                // Only show items with stock > 0
                                                if (parseFloat(item.unitOfMeasurement1) <= 0) return null;
                                                
                                                const isExpired = compareDates(formatDate(item?.expiryDate));
                                                if (isExpired) return null;

                                                return (
                                                <tr
                                                    key={item.id}
                                                    style={{ cursor: isExpired ? 'not-allowed' : 'pointer' }}
                                                    className={isExpired ? 'DisableFontColor2' : ''}
                                                >
                                                    <td className="CleanTable px-2 PnameClass" style={{ width: '5%', textAlign: 'center' }}>
                                                        <Checkbox
                                                            disabled={isExpired}
                                                            checked={selectedItems.some(selectedItem => selectedItem.id === item.id)}
                                                            onChange={() => handleToggleStock(item)}
                                                        />
                                                    </td>
                                                    <td className="CleanTable px-2 text-start PnameClass" style={{ width: '10%' }}>
                                                        {item?.invoiceNumber || '-'}
                                                    </td>
                                                    <td style={{ width: '15%' }}>                                             
                                                        <div style={{
                                                            overflowX: 'auto',
                                                            overflowY: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            maxWidth: '150px',
                                                            marginBottom: '10px',
                                                            marginTop: '-3px',
                                                            padding: '0px 0px 20px',
                                                            display: 'block',
                                                        }}>
                                                            {item?.batchCode || '-'}
                                                        </div>
                                                    </td>
                                                   
                                                    <td className="CleanTable px-2 PnameClass text-center" style={{ width: '15%' }}>
                                                        {formatDate(item?.expiryDate)}
                                                    </td>
                                                    <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass">
                                                        {(function() {
                                                            const value = parseFloat(item?.unitOfMeasurement1 || 1);
                                                            const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
                                                            const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);
                                                            return match ? match[0] : '0';
                                                        })()} {StockProduct2?.unitUomTwo}
                                                    </td>
                                                    <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass">
                                                        
                                                         {(function() {
                                                            const value = parseFloat(item?.unitOfMeasurement1 || 1) * parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
                                                            const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
                                                            const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);
                                                            return match ? match[0] : '0';
                                                        })()} {StockProduct2?.unitUomThree}

                                                    </td>
                                                    <td style={{ width: '23%' }} className="CleanTable PnameClass AddingQty">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                            <Form.Item
                                                                name={`createDate${item.id}`}
                                                                className="text-lable mx-1"
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    style={{ textAlign: 'right', width: '80px' }}
                                                                    className=""
                                                                    disabled={isExpired || !selectedItems.some(selectedItem => selectedItem.id === item.id)}
                                                                    onChange={(event) => {
                                                                        const value = event.target.value;

                                                                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                                                            handleInputChange(event, item);
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        const key = e.key;
                                                                        const value = e.currentTarget.value;

                                                                        const controlKeys = [
                                                                            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                                                                            'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                                                        ];

                                                                        if (controlKeys.includes(key)) return;

                                                                        if (/^[0-9]$/.test(key)) return;

                                                                        if (key === '.' && !value.includes('.')) return;

                                                                        e.preventDefault();
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name={`unitOfMeasurement${item.id}`}
                                                                className="text-lable mx-1"
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <Select
                                                                    className="control-Select mb-1"
                                                                    style={{ width: '80px' }}
                                                                    placeholder="-"
                                                                    onChange={(event) => handleSelectChange(event, item)}
                                                                    disabled={isExpired || !selectedItems.some(selectedItem => selectedItem.id === item.id)}
                                                                    value={selectedItems.find(selectedItem => selectedItem.id === item.id)?.unit2}
                                                                >
                                                                    <Select.Option value={StockProduct2?.unitUomOne}>{StockProduct2?.unitUomOne}</Select.Option>
                                                                    <Select.Option value={StockProduct2?.unitUomTwo}>{StockProduct2?.unitUomTwo}</Select.Option>
                                                                    {StockProduct2?.unitOfMeasurement3 != 1 && <Select.Option value={StockProduct2?.unitUomThree}>{StockProduct2?.unitUomThree}</Select.Option>}
                                                                </Select>
                                                            </Form.Item>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );})}
                                        </tbody>
                                    </table>
                                    {Production.length === 0 && StockProduct2 && (
                                        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                            No stock available for this product from any supplier
                                        </div>
                                    )}
                                </div>
                            </Col>

                            <Col lg={12} md={12} className="d-none">
                                <Form.Item
                                    name="institutionId"
                                    className="text-lable "
                                >
                                    <Input
                                        type="text"
                                        className="control-input"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item
                            name="coSellByDate"
                            label="Sell By Date"
                            className="text-lable mt-3"
                            rules={[
                                {
                                    required: true,
                                    message: "Sell By Date is required",
                                },
                                {
                                    validator: (_, value) => {
                                        if (!value) return Promise.resolve();
                                        
                                        const today = dayjs().startOf('day');
                                        const selected = dayjs(value);
                                        
                                        if (selected.isBefore(today)) {
                                            return Promise.reject(new Error("Date cannot be before today"));
                                        }
                                        
                                        let maxDate = null;
                                        if (Production && Production.length > 0) {
                                            for (const item of Production) {
                                                if (item.expiryDate) {
                                                    const expiryDate = dayjs(item.expiryDate);
                                                    if (!maxDate || expiryDate.isAfter(maxDate)) {
                                                        maxDate = expiryDate;
                                                    }
                                                }
                                            }
                                        }
                                        
                                        if (selectedItems[0]?.expiryDate) {
                                            const selectedItemExpiry = dayjs(selectedItems[0].expiryDate);
                                            if (!maxDate || selectedItemExpiry.isBefore(maxDate)) {
                                                maxDate = selectedItemExpiry;
                                            }
                                        }
                                        
                                        if (maxDate && selected.isAfter(maxDate.endOf('day'))) {
                                            return Promise.reject(new Error(`Date cannot be after ${maxDate.format("DD/MM/YYYY")}`));
                                        }
                                        
                                        return Promise.resolve();
                                    }
                                }
                            ]}
                        >
                            <Input
                                type="date"
                                placeholder="Select Sell By Date"
                                className="control-input"
                                min={dayjs().format("YYYY-MM-DD")}
                                max={(() => {
                                    let maxDate = null;
                                    if (Production && Production.length > 0) {
                                        for (const item of Production) {
                                            if (item.expiryDate) {
                                                const expiryDate = dayjs(item.expiryDate);
                                                if (!maxDate || expiryDate.isAfter(maxDate)) {
                                                    maxDate = expiryDate;
                                                }
                                            }
                                        }
                                    }
                                    if (selectedItems[0]?.expiryDate) {
                                        const selectedItemExpiry = dayjs(selectedItems[0].expiryDate);
                                        if (!maxDate || selectedItemExpiry.isBefore(maxDate)) {
                                            maxDate = selectedItemExpiry;
                                        }
                                    }
                                    return maxDate ? maxDate.format("YYYY-MM-DD") : undefined;
                                })()}
                                onChange={(e) => {
                                    setSelectedSellByDate(e.target.value);
                                    formAdd.setFieldsValue({ coSellByDate: e.target.value });
                                    setTimeout(() => {
                                        setProduction([...Production]);
                                    }, 100);
                                }}
                            />
                        </Form.Item>

                        <p className={StockProduct2 ? '' : 'd-none'} style={{ textAlign: 'start', fontSize: '13px', color: 'blue' }}>
                            <InfoCircleFilled style={{ fontSize: '10px' }} className="inforIcon" />
                            Shelf Life  : {StockProduct2?.shelfLifeDTO?.period} {StockProduct2?.shelfLifeDTO?.periodType}
                        </p>

                        <p style={{ color: 'red' }} className={QuantityValid ? 'mb-2' : 'd-none'}>Quantity is 0</p>

                        <StorageSelectProduction filterHot={false} />

                        <p className={StockProduct2 ? 'pt-3' : 'd-none'} style={{ textAlign: 'start', fontSize: '13px', color: 'blue' }}>
                            <InfoCircleFilled style={{ fontSize: '10px' }} className="inforIcon" />
                            Shelf Life  : {StockProduct2?.storageSuggestionDTO?.name} ({StockProduct2?.storageSuggestionDTO?.description})
                        </p>

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                                padding: "16px 24px 0",
                            }}
                        >
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={btnDisable}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                }}
                            >
                                Add to Cold Tracebility
                            </Button>

                            <Button
                                onClick={handleCancel}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddColdTTrace;